import { Injectable, Output, EventEmitter } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { HttpClientCustom } from './http.client';
import { Configuration } from './configuration';
import { Router } from '@angular/router';
import 'rxjs';
import { AllHtmlEntities } from 'html-entities';

@Injectable()
export class Auth {
  @Output() public updateProfilePic: EventEmitter<any> = new EventEmitter();

  public _userInfo: any;
  public _baseUrl: any;
  public _biUrl: any;
  public _appUrl: any;
  public _tenantLogo: any;
  public _tenant: any;
  @Output() closeFilterValue = new EventEmitter();
  constructor(
    public httpClient: HttpClientCustom,
    public _global: Configuration,
    public router: Router) {
    this._baseUrl = _global.get('EPMS_BASE_URL');
    this._biUrl = _global.get('BI_BASE_URL');
    this._appUrl = _global.get('USER_APP_URL');
  }



  get isAuthenticated(): boolean {
    if (window.localStorage.getItem('activeToken')) {
      return true;
    } else {
      this._userInfo = '';
      return false;
    }
  }

  get userInfo(): any {
    return this._userInfo;
  }



  // tslint:disable-next-line:member-access
  login(username: string, password: string) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded');

    return this.httpClient.post(this._baseUrl + 'login?username='
      + username + '&password=' + password, {},
      { headers }).subscribe((response: Response) => {
        // login successful if there's a jwt token in the response
        if (window.localStorage.getItem('activeToken')) {
          this.router.navigate(['/hub']);
        }
        return true;
      }, (err) => {
        //  this.translate.get('incorrectValues').subscribe((msg)=>{
        alert('incorrectValues');
        // })
      });
  }

  // tslint:disable-next-line:member-access
  user(): Observable<any> {
    if (this._userInfo) {
      return this.createObservable(this._userInfo);
    }
    let self = this;
    return this.httpClient.get(this._baseUrl + 'v1/hub/employeeInfo').map((result) => {
      self._userInfo = result;
      window.localStorage.setItem('userInfo', JSON.stringify(result));
      return self._userInfo;
    });
  }

  // tslint:disable-next-line:member-access
  logout(): void {
    // window.localStorage.removeItem('userInfo');
    // window.localStorage.removeItem('activeToken');
    // let url = this._baseUrl + 'v1/hub/logout';
    // this.httpClient.post(url, {}).subscribe();
    // window.location.href = this._appUrl;

    this._userInfo = '';
    let url = this._baseUrl + 'v1/hub/logout';
    this.httpClient.get(url).subscribe((result) => {
      this.clearLocalStorage();
      window.location.href = this._appUrl+"/";
    }, (err) => {
      this.clearLocalStorage();
      if(err.status == 200) {
        window.location.href=err.headers.get("location");
      } else {
        window.location.href = this._appUrl+"/";
      }
    });
  }

  public clearLocalStorage() {
    window.localStorage.clear();
  }

  public createObservable(data: any): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      observer.next(data);
      observer.complete();
    });
  }

  public handleError(error: any): any {

    console.log(error);
    // return false;
    return Observable.throw(error || 'Server error');
  }

  public get userImage(): any {
    return (this._userInfo && this._userInfo.imageUrl) ? this._userInfo.imageUrl : undefined;
  }

  public get tenantImage(): Observable<any> {
    let self = this;
    if (!this._tenantLogo) {

      return this.httpClient.get(this._baseUrl + 'v1/hub/tenantLogo')
        .map(res => {
          let img = res
          if (img && img.id) {
            self._tenantLogo = img.id;
          }
          return self._tenantLogo;
        }).catch(self.handleError);
    } else {
      return self.createObservable(self._tenantLogo);
    }
  }

  public get tenant(): Observable<any> {
    let self = this;
    if (!this._tenant) {
      return this.httpClient.get(this._baseUrl + '/v2/tenant/getBiLogo')
        .map((res) => {
          self._tenant = res;
          return self._tenant;
        }).catch(self.handleError);
    } else {
      return self.createObservable(self._tenant);
    }
  }

  // tslint:disable-next-line:member-ordering
  public htmlEntitiesDecode(message) {
    try {
      let entities = new AllHtmlEntities();
      return entities.decode(message);
    } catch (e) {
      console.log('Error in htmlEntitiesDecode::', e);
    }
  }

   closeFilter() {
    this.closeFilterValue.emit();
  }

  public updateUser(userInfo) {
    this._userInfo = userInfo;
    console.log(this._userInfo)
    this.setUserInfo(this._userInfo);
    window.localStorage.setItem('userInfo', JSON.stringify(userInfo));
    this.updateProfilePic.emit(userInfo);
  }

  public setUserInfo(data) {
    window.localStorage.setItem('userInfo', JSON.stringify(data));
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/auth.ts